import React from 'react'
import VideoPresentationInternet from './video_presentation_reaseau.mp4'
import VideoPresentationInternetPoster from './video_presentation_reaseau_poster.png'
import useCountUp from '../../Hook/useCountUp'
import Routeur from './Routeur.png'
import Reseau4g from './Reseau4g.png'
import Starlink from './Starlink.png'
import AnimatedSection from '../../Hook/Block'
import TarifsSlide from '../../Hook/TarifsSlide'
import { useState } from 'react'
import SEO from '../../Hook/Seo'
import BreadcrumbsSchema from '../../Hook/BreadcrumbsSchema'
import ImageFadeSlider from '../Telephonie/FadeInTel/FadeInTel'
import New from './New.png'
import Old from './Old.png'
const Internet = () => {
    const [openTarifs, setOpenTarifs] = useState(false)
    const clients1 = useCountUp(120, 2000); // monte jusqu'à 400 en 2 secondes
    return (
        <>
            <SEO
                title="Internet pro : Fibre, 4G/5G backup & Réseaux dans les Vosges | AM Services"
                description="Accès fibre pro, FTTO/FTTH, backup 4G/5G, routeurs, QoS et sécurité réseau."
                path="/internet"
                keywords={["fibre pro", "FTTO", "FTTH pro", "backup 4G", "routeur", "QoS", "réseau entreprise", "Vosges"]}
            />
            <BreadcrumbsSchema />
            <div className="container">
                <div className="div_container">
                    <h1 className="sr-only">Internet pro : fibre, liaisons sécurisées et continuité 4G/5G dans les Vosges</h1>
                    <video
                        src={VideoPresentationInternet}
                        poster={VideoPresentationInternetPoster}
                        autoPlay
                        muted
                        loop
                        preload='auto'
                        playsInline
                        className="background-video"
                        aria-label="Vidéo de présentation des services AM Services"
                    />
                    <div className="info-hero-center-text">
                    <h1 className="info-title">CONNECTIVITÉ INTERNET</h1>
                    <p className="info-lead">
                        Chez AMServices, nous vous assurons une connectivité internet stable et rapide pour votre productivité.
                    </p>
                </div>
                <div className="scroll-indicator" onClick={() => document.getElementById('animatedsection').scrollIntoView({ behavior: 'smooth' })}>
          <span className="arrow"></span>
        </div>
                </div >
                <div id='animatedsection'>
                    <AnimatedSection  
                    sectionTitle="Connectivité Internet"
                    direction="left"
                    items={[
                        {
                            img: Routeur,
                            alt: "Fibre Optique : la puissance de la connexion",
                            title: "Fibre Optique : la puissance de la connexion",
                            text: "En tant que fournisseur internet, AMServices gère l'installation et la maintenance de votre fibre optique de A à Z pour une connectivité stable et ultra-rapide."
                        },
                        {
                            img: Reseau4g,
                            alt: "Dépannage instantané 4G/5G",
                            title: "Dépannage instantané 4G/5G",
                            text: "Avec nos solutions 4G/5G, votre entreprise bénéficie d'une connectivité flexible et performante, partout et à tout moment."
                        },
                        {
                            img: Starlink,
                            alt: "Starlink : l'accès pour tous vos besoins",
                            title: "Starlink : l'accès pour tous vos besoins",
                            text: "La connexion Starlink d'AMServices est une solution internet ultra-performante et fiable, même dans les zones les plus isolées."
                        }
                    ]}
                    count={clients1}
                    countLabel="Clients satisfaits"
                    openTarifs={openTarifs} // ajoute .with-tarifs si open
                />
                </div>
                
                <TarifsSlide
                    buttonLabel="Voir nos tarifs"
                    sectionTitle="Nos Fibres"
                    tarifs={[
                        {
                            title: "Fibre Pro Dédiée Xconnect",
                            description: "Connexion internet dédiée haut débit, assurant stabilité, faible latence et performance optimale pour vos activités professionnelles critiques.",
                            price: "62,00€ HT/mois"
                        },

                        { title: "Fibre Pro SecureLite 4G", description: "Sauvegarde automatique 4G limitée à 10 Go, pensée pour assurer la continuité optimal du service", price: "79,00€ HT/mois" },
                        { title: "Fibre Pro Continuum + DMG/GTR", description: "Met en avant la garantie de débit et la réactivité (8h), rassurant sur la haute disponibilité", price: "133,00€ HT/mois" },
                    ]}
                    openTarifs={openTarifs}
                    setOpenTarifs={setOpenTarifs} // bouton contrôle l'état global
                />

                <div className="fadinetel" >
                    <h2 className='section-title'>
                        L’ADSL disparaît dès 2026 — préparez la transition dès aujourd’hui
                    </h2>
                    <p>La fin du réseau cuivre impacte directement les entreprises et professionnels.
                        Assurez la continuité de vos connexions et services grâce à nos solutions fibre fiables et pérennes, conformes aux nouveaux standards.</p>
                    <ImageFadeSlider
                        oldImage={New}
                        newImage={Old}
                    />
                </div>
            </div>
        </>
    )
}

export default Internet
